export default __webpack_public_path__ + "static/media/bolt.329aeb6f.jpg";